// extracted by mini-css-extract-plugin
export var card = "_m7-5";
export var cardSelected = "_m7-4";
export var image = "_m7-3";
export var modal = "_m7-0";
export var modalContent = "_m7-1";
export var table = "_m7-2";